import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from "react-i18next";
import {
  c2DialogPaperSx,
  c2DialogTitleSx,
  c2IconBoxSx,
  c2DialogBodySx,
  c2PrimaryBtnSx,
  c2SecondaryBtnSx,
} from './conecta2ModalStyles';

const ES_FALLBACKS = {
  profile_incomplete: 'Completa tu perfil (nombre, correo y teléfono) para continuar.',
};

function resolveMessage(children, t) {
  if (typeof children !== 'string') return children;
  const keyLike = /^[a-z][a-z0-9_]*$/i.test(children);
  if (keyLike && (ES_FALLBACKS[children] || children.includes('_'))) {
    return t(children, { defaultValue: ES_FALLBACKS[children] || children });
  }
  return children;
}

export default function AlertDialogTwoButton(props) {
  const { t } = useTranslation();
  const { open, onClose, children, onGoto } = props;
  const message = resolveMessage(children, t);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ sx: c2DialogPaperSx }}
    >
      <DialogTitle id="alert-dialog-title" sx={c2DialogTitleSx}>
        <Box sx={c2IconBoxSx}>
          <InfoOutlinedIcon sx={{ color: '#6411ED', fontSize: 22 }} />
        </Box>
        {t('alert', { defaultValue: 'Aviso' })}
      </DialogTitle>
      <DialogContent sx={{ px: 2.5, pb: 1 }}>
        <DialogContentText id="alert-dialog-description" sx={{ ...c2DialogBodySx, pt: 0.5 }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 2.5, pt: 1, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" sx={c2SecondaryBtnSx}>
          {t('close', { defaultValue: 'Cerrar' })}
        </Button>
        <Button onClick={onGoto} variant="contained" sx={c2PrimaryBtnSx}>
          {t('goto', { defaultValue: 'Ir al perfil' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
